const MERCHANTVIEW_API_BE = 'https://merchant.vietinbank.vn/';

// vnpay
// const MERCHANTVIEW_API_BE = 'https://mcviewvtb.backendofficetest.vn/';

/// uat
// const MERCHANTVIEW_API_BE = 'http://10.6.145.186:6003/';

export default {
  MERCHANTVIEW_API_BE,
};
